/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ban_Stop_GenocideInputs */

const en_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop genocide in`)
};

const ar_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوقفوا الإبادة في`)
};

const bn_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গণহত্যা বন্ধ করুন`)
};

const de_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoppen Sie den Völkermord in`)
};

const es_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto al genocidio en`)
};

const fr_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter le génocide`)
};

const pt_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pare o genocídio em`)
};

const zh_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止种族灭绝`)
};

const tr_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soykırımı durdurun`)
};

const ru_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остановить геноцид в`)
};

const pl_ban_stop_genocide = /** @type {(inputs: Ban_Stop_GenocideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrzymaj ludobójstwo`)
};

/**
* | output |
* | --- |
* | "Stop genocide in" |
*
* @param {Ban_Stop_GenocideInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ban_stop_genocide = /** @type {((inputs?: Ban_Stop_GenocideInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ban_Stop_GenocideInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ban_stop_genocide(inputs)
	if (locale === "bn") return bn_ban_stop_genocide(inputs)
	if (locale === "de") return de_ban_stop_genocide(inputs)
	if (locale === "es") return es_ban_stop_genocide(inputs)
	if (locale === "fr") return fr_ban_stop_genocide(inputs)
	if (locale === "pt") return pt_ban_stop_genocide(inputs)
	if (locale === "zh") return zh_ban_stop_genocide(inputs)
	if (locale === "tr") return tr_ban_stop_genocide(inputs)
	if (locale === "ru") return ru_ban_stop_genocide(inputs)
	if (locale === "pl") return pl_ban_stop_genocide(inputs)
	return en_ban_stop_genocide(inputs)
});